export const MAX_STORES = 9;
export const STORE_INCREMENT = 3;
